<template>
  <svg xmlns="http://www.w3.org/2000/svg">
    <path d="m12 8.29492-6 5.99998 1.41 1.41 4.59-4.58 4.59 4.58 1.41-1.41z" />
  </svg>
</template>
